import React from "react";
import { object, number } from "prop-types";
// import { useSelector } from "react-redux";
// import get from "lodash/get";
// import { WithLazy, ResponsiveImage, StoryElement } from "@quintype/components";

import StoryHeader from "../story-header";
import StoryElements from "../story-elements";
import StorySideBar from "../story-sidebar";

import "./podcast.m.css";

import StorySeparator from "../../atoms/story-separator";

const PodCastStoryTemplate = ({ story, index }) => {
  return (
    <>
      {index > 0 && <StorySeparator />}
      <div styleName="story-wrapper">
        <div className="story-section">
          <div>
            <StoryHeader story={story} isPodCast showHeroImage={false} />
            <StoryElements story={story} cards={story.cards} index={index} isPodcast />
          </div>
        </div>

        <div className="side-story-section">
          <StorySideBar index={index} story={story} />
        </div>
        {/* <div className="more-news-section">
          <MoreNews story={story} />
        </div> */}
      </div>
    </>
  );
};

PodCastStoryTemplate.propTypes = {
  story: object,
  index: number
};

const PodCastStory = (props) => {
  return <PodCastStoryTemplate story={props.story} index={props.index} />;
};

PodCastStory.propTypes = {
  story: object,
  index: number
};

export default PodCastStory;
